import {getDeclension} from "../utils/common";

const preFilter = ({filterForm, buttonTextSelector = `.js-filter-inform-text`}) => {
  const informTextElement = filterForm.querySelector(buttonTextSelector);
  const URL = `/site/amount`;
  // const URL = `/data/pre-filter.json`;

  const postData = async (data, url) => {
    const options = {
      method: `POST`,
      body: data,
    };

    const result = await fetch(url, options);

    return await result.json();
  };

  filterForm.addEventListener(`change`, (evt) => {
    const formData = new FormData(filterForm);
    formData.append(`category`, document.location.pathname);
    postData(formData, URL).then(({amount}) => {
      if (amount >= 0) {
        informTextElement.textContent = `Показать ${amount} ${getDeclension(amount, [
          `принт`,
          `принта`,
          `принтов`,
        ])}`;
      }
    });
  });
};

export default preFilter;
